import { Loader } from "@shared/ui/Loader";
import { Quiz } from "./Quiz";
import { useGetQuizResponse } from "./useGetQuizResponse";

type Props = {
  quizResponseId: number;
  onCompleteQuiz: () => void;
};

export function QuizContainer({ quizResponseId, onCompleteQuiz }: Props) {
  const { quiz, isLoading } = useGetQuizResponse({ quizResponseId });

  if (isLoading || !quiz) return <Loader isFullPage />;

  return (
    <Quiz
      quiz={quiz}
      quizResponseId={quizResponseId}
      onCompleteQuiz={onCompleteQuiz}
    />
  );
}

export default QuizContainer;
